module.exports = __webpack_public_path__ + "img/29.26cc4a82.png";